import { useEffect, useState } from 'react';
import { Box, Stack } from '@mui/material';
import CustomInputField from '../../ui/primitives/CustomInputField';
import CustomSelect from '../../ui/primitives/CustomSelect';
import ActionButton from '../../ui/primitives/ActionButton';

const fieldTypeOptions = [
  { id: 'text', name: 'Text' },
  { id: 'number', name: 'Number' },
  { id: 'date', name: 'Date' },
  { id: 'boolean', name: 'Boolean' },
];

const AddForm = ({ entityType, group, handleSubmit, entity = '' }) => {
  const initialFormData = {
    name: '',
    description: '',
    color: '#FFAB00',
    group: group,
    type: '',
    isRequired: false,
  };

  const [formData, setFormData] = useState(initialFormData);
  const [buttonLoading, setButtonLoading] = useState(false);

  const handleInputChange = (id, value) => {
    setFormData((prevData) => ({ ...prevData, [id]: value }));
  };

  const handleColorChange = (e) => {
    setFormData((prevData) => ({ ...prevData, color: e.target.value }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name) return;
    setButtonLoading(true);
    try {
      const payload = {
        name: formData.name,
        description: formData.description,
        color: formData.color,
        group: formData.group,
        type: formData.type || null,
        isRequired: false,
      };
      await handleSubmit(payload);
      setFormData(initialFormData);
    } catch (error) {
      console.error('Failed to submit form:', error);
    } finally {
      setButtonLoading(false);
    }
  };

  const shouldShowColor =
    entityType?.includes('status') || entityType?.includes('priority');
  const shouldShowDescription =
    entityType?.includes('labels') || entityType?.includes('fields');

  useEffect(() => {
    setFormData(initialFormData);
  }, [entityType]);

  return (
    <Box component="form" onSubmit={handleFormSubmit}>
      <Stack direction="row" spacing={2} alignItems="flex-end" flexWrap="wrap" useFlexGap>
        <Box sx={{ flex: 1, minWidth: 160 }}>
          <CustomInputField
            id="name"
            label="Name"
            required
            placeholder="Name"
            value={formData.name}
            onChange={handleInputChange}
          />
        </Box>

        {!shouldShowDescription && (
          <Box sx={{ flex: 2, minWidth: 200 }}>
            <CustomInputField
              id="description"
              label="Description"
              placeholder="Description"
              value={formData.description}
              onChange={handleInputChange}
            />
          </Box>
        )}

        {shouldShowColor && (
          <Box>
            <Box
              component="input"
              type="color"
              value={formData.color}
              onChange={handleColorChange}
              sx={{
                width: 40,
                height: 40,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                cursor: 'pointer',
                p: 0.25,
              }}
            />
          </Box>
        )}

        <ActionButton
          label={`+ Add New ${entity}`}
          intent="primary"
          loading={buttonLoading}
          disabled={!formData.name || buttonLoading}
          onClick={handleFormSubmit}
          tooltip={`Add`}
        />
      </Stack>
    </Box>
  );
};

export default AddForm;